module.exports = __webpack_public_path__ + "img/Graph-1.3cfd937d.svg";